var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-upload-img"},[_c('input',{ref:"inputDom",attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.upload}}),_vm._v(" "),_c('p',[_vm._v(" Upload Photo")]),_vm._v(" "),_c('img',{staticClass:"user xx-large",attrs:{"src":_vm.img}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c82c33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landings/MUploadImg.vue
// module id = null
// module chunks = 